"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeArray = void 0;
exports.IkeArray = {
    /**
     *  Shallow clone a array
     *
     * @returns New array of elements
     **/
    clone(ary) {
        if (ary == null) {
            return [];
        }
        return ary.slice();
    },
    /**
     * Produces a duplicate-free version of the array.
     *
     * @param arr Array to iterate over.
     * @param key Key used to identify duplicate objects.
     */
    uniqueBy(arr, key) {
        if (!Array.isArray(arr)) {
            return [];
        }
        const seen = {};
        const uniqueArr = [];
        for (const item of arr) {
            if (item == null) {
                continue;
            }
            const seenKey = item[key];
            if (seenKey != null && !seen[seenKey]) {
                seen[seenKey] = true;
                uniqueArr.push(item);
            }
        }
        return uniqueArr;
    },
    /** Recursively flattens an array. */
    flatten(data, output = []) {
        for (const ary of data) {
            if (Array.isArray(ary)) {
                exports.IkeArray.flatten(ary, output);
            }
            else {
                output.push(ary);
            }
        }
        return output;
    },
    /**
     * Convert an array of objects to a map with each unique value assigned to the provided key.
     * @param arr Objects to convert into a map
     * @param key Key inside the object to use for conversion
     */
    toMap(arr, key) {
        const output = {};
        for (const obj of arr) {
            output[obj[key]] = obj;
        }
        return output;
    },
    /**
    * Convert an array of objects to a map with each array of values assigned to the provided key.
    * @param arr Objects to convert into a map
    * @param key Key inside the object to use for conversion
    */
    groupBy(arr, key) {
        const output = {};
        for (const obj of arr) {
            const value = obj[key];
            if (output[value] == null) {
                output[value] = [obj];
            }
            else {
                output[value].push(obj);
            }
        }
        return output;
    },
    /**
     * Get the values in one array which are not found in the second.
     * Both arrays are treated as sets.
     *
     * @param arr1 Original Array
     * @param arr2 Other Array
     * @returns Values of `arr1` not in `arr2`
     */
    difference(arr1, arr2) {
        const store = new Set(arr2);
        const result = [];
        for (const value of arr1) {
            if (!store.has(value)) {
                result.push(value);
            }
        }
        return result;
    },
    // differenceObj<T>(arr1: T[], arr2: T[], key): T[];
    /**
     * Creates an array of elements split into groups the length of size. If array can't be split evenly, the final chunk will be the remaining elements.
     *
     * @param array The array to process.
     * @param size The length of each chunk.
     * @returns The new array of chunks.
     */
    chunk(array, size) {
        const chunks = [];
        if (array == null || array.length === 0) {
            return chunks;
        }
        const count = Math.ceil(array.length / size);
        for (let i = 0; i < count; i++) {
            const currentChunk = array.slice(i * size, (i + 1) * size);
            chunks.push(currentChunk);
        }
        return chunks;
    }
};
//# sourceMappingURL=array.js.map